import { useEffect, useState } from 'react';

type ConnectionInfo = {
  effectiveType: string;
  downlink: number;
  rtt: number;
  saveData: boolean;
};

export const useConnectionInfo = (): ConnectionInfo | null => {
  const getConnection = () =>
    // @ts-ignore
    navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection;

  const [connectionInfo, setConnectionInfo] = useState<ConnectionInfo | null>(() => {
    const conn = getConnection();
    console.log({ conn });
    return conn
      ? {
          effectiveType: conn.effectiveType,
          downlink: conn.downlink,
          rtt: conn.rtt,
          saveData: conn.saveData,
        }
      : null;
  });

  useEffect(() => {
    const conn = getConnection();
    console.log(111, { conn });
    if (!conn) return;

    const updateConnectionInfo = () => {
      setConnectionInfo({
        effectiveType: conn.effectiveType,
        downlink: conn.downlink,
        rtt: conn.rtt,
        saveData: conn.saveData,
      });
    };

    conn.addEventListener('change', updateConnectionInfo);

    return () => {
      conn.removeEventListener('change', updateConnectionInfo);
    };
  }, []);

  useEffect(() => {
    const handleOfflineState = () => {
      setConnectionInfo(
        (prevState) =>
          prevState && {
            ...prevState,
            effectiveType: 'offline',
          },
      );
    };

    window.addEventListener('offline', handleOfflineState);

    return () => {
      window.removeEventListener('offline', handleOfflineState);
    };
  }, []);

  return connectionInfo;
};
